
export class AcademicProfessionalAssociation {
    constructor(
        public readonly name: string,
        public readonly description: string
    ){}
}